import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as brandAction from '../actions/brand.action';
import {map, switchMap, catchError, mergeMap, take, withLatestFrom, filter} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as fromStore from '../../../store';
import {isNullOrUndefined} from 'util';
import {BrandService} from '../../brand.service';


@Injectable()
export class BrandEffect {
  constructor(private actions: Actions, private brandService: BrandService, private store: Store<fromStore.AppState>) {
  }

  @Effect()
  getAllBrands: Observable<Action> = this.actions.ofType(brandAction.GET_ALL_BRANDS)
    .pipe(
      switchMap(() => {
        return this.brandService.getAllBrands()
          .map(res => new brandAction.GetAllBrandsSuccess(res))
          .catch(error => of(new brandAction.GetAllBrandsError(error)));
      })
    );

  @Effect()
  getBrand: Observable<Action> = this.actions.ofType(brandAction.GET_BRAND)
    .pipe(
      withLatestFrom(
        // select brands.
        this.store.select(state => state.brandsFeature.brands.entities),
        (action: any, brands) => {
          // if no brands present, proceed for API.
          if (isNullOrUndefined(brands)) {
            return action;
          } else {
            // brands exists in store.
            const brand = brands.filter(b => b.id === action.payload)[0];
            if (!!brand) {
              // if required brand is present in store, then return;
              return undefined;
            } else {
              // if required brands not present in store, then proceed for API.
              return action;
            }
          }
        }
      ),
      filter(action => !!action),
      mergeMap(action => {
        return this.brandService.getBrand(action.payload)
          .map(res => new brandAction.GetBrandSuccess(res))
          .catch(error => of(new brandAction.GetBrandError(error)));
      })
    );

  @Effect()
  getBrandManagers: Observable<Action> = this.actions.ofType(brandAction.GET_BRAND_MANAGERS)
    .pipe(
      mergeMap(action => {
        return this.brandService.getBrandManagers()
          .map(res => new brandAction.GetBrandManagersSuccess(res))
          .catch(error => of(new brandAction.GetBrandManagersError(error)));
      })
    );

  @Effect()
  createBrand: Observable<Action> = this.actions.ofType(brandAction.ADD_BRAND)
    .map((action: brandAction.AddBrand) => action.payload)
    .pipe(
      switchMap(body => {
        return this.brandService.createBrand(body)
          .map(res => new brandAction.AddBrandSuccess(res))
          .catch(error => of(new brandAction.AddBrandError(error)));
      })
    );

  @Effect()
  updateBrand: Observable<Action> = this.actions.ofType(brandAction.UPDATE_BRAND)
    .map((action: brandAction.AddBrand) => action.payload)
    .pipe(
      switchMap(body => {
        return this.brandService.updateBrand(body)
          .map(res => new brandAction.UpdateBrandSuccess(res))
          .catch(error => of(new brandAction.UpdateBrandError(error)));
      })
    );
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/brands/store/effects/brand.effect.ts